module.exports = __webpack_public_path__ + "img/me.4b0924ad.jpeg";